import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { internalDocumentApi } from 'features/internal-document/common/query';
import type { TInternalDocumentState } from 'features/internal-document/common/types';
import type { TIncomingInternalDocumentDetail } from 'features/internal-document/incoming/types';
import type { TOutgoingInternalDocumentDetail } from 'features/internal-document/outgoing/types';
import type { StrictUnion } from 'shared/types';

const initialState: TInternalDocumentState = {
  internalDocumentDetail: null,
  internalDocumentComments: null,
};

const internalDocumentSlice = createSlice({
  name: 'internalDocument',
  initialState,
  reducers: {
    setInternalDocumentDetail: (
      state,
      action: PayloadAction<StrictUnion<
        TIncomingInternalDocumentDetail | TOutgoingInternalDocumentDetail
      > | null>
    ) => {
      state.internalDocumentDetail = action.payload;
    },
  },
  extraReducers: builder => {
    const { GetInternalDocumentDetail, GetInternalDocumentComments } =
      internalDocumentApi.endpoints;

    builder
      .addMatcher(
        GetInternalDocumentDetail.matchFulfilled,
        (state, { payload }) => {
          state.internalDocumentDetail = payload;
        }
      )
      .addMatcher(
        isAnyOf(
          GetInternalDocumentDetail.matchRejected,
          GetInternalDocumentDetail.matchPending
        ),
        state => {
          state.internalDocumentDetail = null;
        }
      )
      .addMatcher(
        GetInternalDocumentComments.matchFulfilled,
        (state, { payload }) => {
          state.internalDocumentComments = payload;
        }
      )
      .addMatcher(
        isAnyOf(
          GetInternalDocumentComments.matchPending,
          GetInternalDocumentComments.matchRejected
        ),
        state => {
          state.internalDocumentComments = null;
        }
      );
  },
});

export const { setInternalDocumentDetail } = internalDocumentSlice.actions;
export default internalDocumentSlice.reducer;
